import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

import Dashboard from '../pages/SiteAdmin/Dashboard/Dashboard';
import Posts from '../pages/SiteAdmin/Posts/Posts';
import Events from '../pages/SiteAdmin/Events/Events';
import Media from '../pages/SiteAdmin/Media/Media';
import Settings from '../pages/SiteAdmin/Settings/Settings';
import CreatePost from '../pages/SiteAdmin/Posts/CreatePost';
import EditPost from '../pages/SiteAdmin/Posts/EditPost';

const SiteAdminRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/posts/create" element={<CreatePost />} />
        <Route path="/posts/edit/:postId" element={<EditPost />} />
        <Route path="/events" element={<Events />} />
        <Route path="/media" element={<Media />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
};

export default SiteAdminRoutes;